import { useCallback, useState } from 'react';
import { HelpOutline, ErrorOutline } from '@mui/icons-material';
import { CircularProgress, IconButton, useTheme } from '@mui/material';
import { analytics, events } from 'services/analytics';
import { aiMusicGeneratorAwsApi } from 'services/api/aiMusicGenerator/aiMusicGeneratorApi';
import useDrawerState from '../../MobileFormulaDrawer/useDrawerState';
import MobileInfoArticle from './Article/MobileInfoArticle';
import MobileInfoMenu from './Menu/MobileInfoMenu';

const OPEN_MENU_DELAY = 200;
const OPEN_FORMULA_DRAWER_DELAY = 300;

const MobileInfoGuide = () => {
  const theme = useTheme();
  const { close, open } = useDrawerState();

  const [openMenu, setMenuOpen] = useState<boolean>(false);
  const [openArticle, setOpenArticle] = useState<boolean>(false);
  const [value, setValue] = useState<number | null>(null);

  const {
    data = null,
    error,
    isLoading: loading,
  } = aiMusicGeneratorAwsApi.useGetInfoGuideQuery();

  const handleOpenMenu = useCallback(() => {
    if (loading || error) {
      return;
    }
    setTimeout(close, 0);
    setTimeout(() => setMenuOpen(!openMenu), OPEN_MENU_DELAY);
    analytics.track(events.infoGuideClick());
  }, [loading, error, close, openMenu]);

  const handleClick = useCallback((newValue: number) => {
    setValue(newValue);
    setOpenArticle(true);
  }, []);

  const handleClose = useCallback(() => {
    setValue(null);
    setMenuOpen(false);
    setOpenArticle(false);
    setTimeout(open, OPEN_FORMULA_DRAWER_DELAY);
  }, [open]);

  const handleBack = useCallback(() => {
    setValue(null);
    setOpenArticle(false);
  }, []);

  const displayIcon = useCallback(() => {
    if (error) {
      return <ErrorOutline />;
    }
    if (loading) {
      return <CircularProgress color="primary" size={20} />;
    }
    return <HelpOutline />;
  }, [loading, error]);

  return (
    <>
      <IconButton
        sx={{
          width: theme.spacing(5),
          height: theme.spacing(5),
          color: theme.palette.grey[50],
          backgroundColor: theme.palette.grey[700],
        }}
        size="small"
        aria-controls={openMenu ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : undefined}
        onClick={handleOpenMenu}
      >
        {displayIcon()}
      </IconButton>

      <MobileInfoMenu
        data={data}
        open={openMenu}
        index={0}
        value={value}
        handleClick={handleClick}
        handleClose={handleClose}
      />
      <MobileInfoArticle
        data={data}
        value={value}
        open={openArticle}
        handleClose={handleClose}
        handleBack={handleBack}
      />
    </>
  );
};

export default MobileInfoGuide;
